import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import TaskTemplateTableActions from '@/components/task-templates/TaskTemplateTableActions.vue';
import type { TaskTemplate } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<TaskTemplate>[] = [
    {
        accessorKey: 'id',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'task-templates.table.name',
            }),
        sortingFn: 'text',
    },
    {
        accessorKey: 'description',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'task-templates.table.description',
            }),
        sortingFn: 'text',
    },
    {
        accessorKey: 'tasks_string',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'task-templates.table.tasks_string',
            }),
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(TaskTemplateTableActions, {
                taskTemplate: row.original,
            });
        },
    },
];
